<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :fechaDesde="fechaDesdeParam"
          :fechaHasta="fechaHastaParam"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
          <b-card header="Resumen de Gastos" class="resumen-gastos">
            <b-table class="registro" responsive="sm" 
                :items="cuentasDisplay" 
                :fields="fields"
                :busy="tableBusy"
                @row-clicked="itemClicked">
              <div slot="table-busy" class="text-center">
                <b-spinner variant="primary" label="Spinning" />
              </div>              
              <template v-slot:cell(monto)="data">
                {{ data.item.monto | moneda }}
              </template>
            </b-table>
          </b-card>
        </transition>

        <transition name="slide">
          <b-card header="Listado de Comprobantes" 
              class="resumen-gastos-comprobantes"
              v-if="comprobantes.length != 0">

            <b-form-group
              label="Cuenta"
              label-for="cuenta"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="cuenta" 
                :value="cuenta" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Rubro"
              label-for="rubro"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="rubro" 
                :value="rubro" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Subrubro"
              label-for="subrubro"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="subrubro" 
                :value="subrubro" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Proveedor"
              label-for="proveedor"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="proveedor" 
                :value="proveedor" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-table 
                class="registro" responsive="sm" 
                :items="comprobantes" 
                :fields="comprobantesFields"
                @row-clicked="consultar">
              <div slot="table-busy" class="text-center">
                <b-spinner variant="primary" label="Spinning" />
              </div>              
              <template v-slot:cell(fechaComprobante)="data">
                {{ data.item.fechaComprobante | fecha }}
              </template>
              <template v-slot:cell(monto)="data">
                {{ data.item.monto | moneda }}
              </template>
            </b-table>
          </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="exportarResumenGastos">
            <i class="fa fa-file-excel-o"></i>Exportar Resumen de Gastos</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Filtro from './listFiltro.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import exportResumenGastos from '../../mixins/export_xls_resumen_gastos';
import moment from 'moment'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'resumenGastos/getField',
  mutationType: 'resumenGastos/updateField',
});

export default {
  name: 'ResumenGastos',
  components: {
    appFiltro: Filtro,
    appMensaje: Mensaje
  },
  mixins: [
    exportResumenGastos,
    msjModal
  ],
  props: {
    inicializar: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      fields: [
        // { key: 'cuentaId' },
        // { key: 'rubroId' },
        // { key: 'subrubroId' },
        { key: 'nombre' },
        // { key: 'proveedor' },
        // { key: 'comprobante' },
        { 
          key: 'monto',
          class: 'text-right'
        },
        // {
        //   key: 'opciones',
        //   label: '',
        // },
      ],

      comprobantesFields: [
        { key: 'fechaComprobante' },
        { key: 'comprobante' },
        { 
          key: 'monto',
          class: 'text-right'
        },
      ],

      tableBusy: false,
      labelCols: 1
    }
  },
  computed: {
    ...mapFields([
      'cuentasDisplay',
      'fechaDesde',
      'fechaHasta',
      'comprobantes',
      'cuenta',
      'rubro',
      'subrubro',
      'proveedor',
    ]),
    fechaDesdeParam () {
      return moment(this.fechaDesde).format('YYYY-MM-DD');
    },
    fechaHastaParam () {
      return moment(this.fechaHasta).format('YYYY-MM-DD');
    },
  },
  created() {
    if (this.inicializar) {
      this.$store.dispatch('resumenGastos/inicializar');
    }
  },  
  methods: {
    getResumenGastos() {
      this.tableBusy = true;
      this.$store.dispatch('resumenGastos/getResumenGastos')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    filtrar(filtro) {
      this.fechaDesde = filtro.fechaDesde;
      this.fechaHasta = filtro.fechaHasta;

      this.getResumenGastos();
    },
    itemClicked(item) {
      if (item.proveedorId != 0) {
        let params = {
          cuentaId: item.cuentaId,
          rubroId: item.rubroId,
          subrubroId: item.subrubroId,
          proveedorId: item.proveedorId,
        }
        this.$store.dispatch('resumenGastos/setComprobantes', params);
      } else if (item.subrubroId != 0) {
        this.$store.dispatch('resumenGastos/expandirContraerSubrubro', item.subrubroId);
      } else if (item.rubroId != 0) {
        this.$store.dispatch('resumenGastos/expandirContraerRubro', item.rubroId);
      } else if (item.cuentaId != 0) {
        this.$store.dispatch('resumenGastos/expandirContraerCuenta', item.cuentaId);
      }
    },
    consultar (item) {
      this.$router.push({ name: 'ResumenGastosDatos', 
                          params: { id: item.id } });
    },
    exportarResumenGastos() {
      let rptCuentas = this.$store.getters['resumenGastos/rptCuentas'];

      let exportarResumen = false;
      if (rptCuentas) {
        if (rptCuentas.cuentas.length != 0) {
          exportarResumen = true;
        }
      }
      if (exportarResumen) {
        this.exportXls(rptCuentas);
      } else {
        this.showModalMsj('No hay datos para exportar', null, null, 'light');
      }

    }
  },
  watch: {
  }
}
</script>

<style>
  .resumen-gastos table thead th {
    border-top: none;
  }
  .resumen-gastos table td[aria-colindex="1"] {
    width: 80%;
  }
  .resumen-gastos .table-cuenta {
    font-weight: 700;
    background-color: var(--table-tr-hover-bg);
  }
  .resumen-gastos .table-rubro {
    font-weight: 600;
  }
  .resumen-gastos .table-rubro td[aria-colindex="1"] {
    padding-left: 30px;
  }
  .resumen-gastos .table-subrubro td[aria-colindex="1"] {
    padding-left: 50px;
  }
  .resumen-gastos .table-proveedor {
    font-style: italic;
    color: rgb(97, 136, 168);
  }
  .resumen-gastos .table-proveedor td[aria-colindex="1"] {
    padding-left: 80px;
  }
  .resumen-gastos .table-totales {
    font-weight: 700;
    background-color: var(--table-tr-hover-bg);
  }
  .resumen-gastos-comprobantes .form-group {
    margin-bottom: 5px;
  }
  .resumen-gastos-comprobantes .registro {
    margin-top: 25px;
  }
  .resumen-gastos-comprobantes table thead th {
    border-top: none;
  }
</style>
